/**
 * Citizen of Lagos — transparent-over-hero header.
 * Only activates when the homepage's first section is a full-bleed image
 * banner, so the header can sit transparent over it and solidify on scroll
 * (via Dawn's own `shopify-section-header-sticky` class). Self-correcting:
 * if the hero is ever removed, overlay mode simply never turns on.
 */
(function () {
  if (!document.body.classList.contains('cit-index')) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  // The first rendered section on the page.
  var firstSection = main.querySelector('.shopify-section');
  if (!firstSection) return;

  // Treat it as a hero only if it's an image banner with real overlay content.
  var banner = firstSection.querySelector('.banner');
  if (banner) {
    document.body.classList.add('cit-hero-active');
  }
})();
